/**
 * 21/10/2026 — Re-pick the list (user: "when changing the list groups or the
 * formula it doesn't change in the drop slots"): the button's hook. One
 * group of the container, or every group (null); the toast says what the
 * engine did — the list each group was on is forgotten, its burns kept, a
 * day already laid out re-synced.
 * For Media Devoted | Created By Ciro Autiero
 */
import { getApiErrorMessage } from '@/lib/utils';
import { useToast } from '@/providers/ToastProvider';

import { type RepickOutcome, useVerdictMutations } from '../../../../useVerdictMutations';

export function repickWords(out: RepickOutcome): string {
  if (out.pairs === 0) return 'Nothing to forget — no list was picked yet, so the slots already show the first list of the order.';
  return `The slots show the first list of the order as it is now${out.resynced ? " — today's unsent drafts moved with it" : ''}.`;
}

export function useRepick(countryKey: string, containerId: string | null) {
  const { repickList } = useVerdictMutations();
  const { success, error } = useToast();
  const repick = async (listGroupId: string | null) => {
    if (!containerId) return;
    try {
      const out = await repickList.mutateAsync({ countryKey, containerId, listGroupId });
      success(listGroupId ? 'List re-picked' : 'Lists re-picked', repickWords(out));
    } catch (err) {
      error('The list could not be re-picked', getApiErrorMessage(err));
    }
  };
  return { repick, pending: repickList.isPending };
}
